
import { Component, Vue } from 'vue-property-decorator'

/**
 * HeroBanner component for FAQ page
 * Only visible on PC (> 650px)
 * Image ratio 1240:420, centered with red background outside
 */
@Component
export default class HeroBanner extends Vue {}
